import { createSlice } from '@reduxjs/toolkit';
import { fetchDefaultCategories, fetchQurbaniCategories, updateCategoryStatus } from '../thunk/categoryThunk';

const initialState = {
    defaultCategories: [],
    defaultCategoriesLoading: false,
    defaultCategoriesError: null,
    qurbaniCategories: [],
    qurbaniCategoriesLoading: false,
    qurbaniCategoriesError: null,
    updateStatusLoading: false,
    updateStatusError: null,
};
const categorieSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDefaultCategories.pending, (state) => {
                state.defaultCategoriesLoading = true;
                state.defaultCategoriesError = null;
            })
            .addCase(fetchDefaultCategories.fulfilled, (state, action) => {
                state.defaultCategoriesLoading = false;
                state.defaultCategories = action.payload.data;
            })
            .addCase(fetchDefaultCategories.rejected, (state, action) => {
                state.defaultCategoriesLoading = false;
                state.defaultCategoriesError = action.payload;
            })
            //
            .addCase(fetchQurbaniCategories.pending, (state) => {
                state.qurbaniCategoriesLoading = true;
                state.qurbaniCategoriesError = null;
            })
            .addCase(fetchQurbaniCategories.fulfilled, (state, action) => {
                state.defaultCategoriesLoading = false;
                state.qurbaniCategories = action.payload.data;
            })
            .addCase(fetchQurbaniCategories.rejected, (state, action) => {
                state.qurbaniCategoriesLoading = false;
                state.qurbaniCategoriesError = action.payload;
            })
            // Update a Categories
            .addCase(updateCategoryStatus.pending, (state) => {
                state.updateStatusLoading = true;
                state.updateStatusError = null;
            })
            .addCase(updateCategoryStatus.fulfilled, (state, action) => {
                state.updateStatusLoading = false;
                state.updateStatusError = action.payload.data;
            })
            .addCase(updateCategoryStatus.rejected, (state, action) => {
                state.updateStatusLoading = false;
                state.updateStatusError = action.payload;
            });
    },
});

export default categorieSlice.reducer;

// Selectors
export const selectDefaultCategories = (state) => state.categories.defaultCategories;
export const selectDefaultCategoriesLoading = (state) => state.categories.defaultCategoriesLoading;
export const selectDefaultCategoriesError = (state) => state.categories.defaultCategoriesError;
//
export const selectQurbaniCategories = (state) => state.categories.qurbaniCategories;
export const selectQurbaniCategoriesLoading = (state) => state.categories.qurbaniCategoriesLoading;
export const selectQurbaniCategoriesError = (state) => state.categories.qurbaniCategoriesError;
